export default __webpack_public_path__ + "static/media/logo.f010984d.svg";